export default __webpack_public_path__ + "static/media/question.534f0a1f.svg";